import React, {useState} from 'react';
import TeamMemberFilters from './TeamMemberFilters.mjs';
import TeamMemberList from './TeamMemberList.mjs';
import './Card.css';
import { useCTAL } from './CTAL_Hooks.js';


const DEBUG = 0;

export default function TeamMemberCard({team_id}) 
{
    const { team_members_list } = useCTAL();

    const [show_filter_options, showFilterOptions] = useState(false);
    const [filter_form, setFilterForm] = useState("");

    if ((!team_members_list) || (team_members_list.length == 0)) return;

    const show_members_filters = () => {
        if (show_filter_options)
        {
            showFilterOptions(false);
            setFilterForm(<></>);
            return;
        }

        showFilterOptions(true);

        setFilterForm ( <> <TeamMemberFilters /> </> );
    } 

    if (DEBUG) return;

    return (
        <>
            <div class="card mt-2">
                <div id="team-member-card-header" class="card-header">
                    <div class="row">
                        <div id="team-member-title" class="col text-start">
                            <a href="#"><img class="card-icon" src="./images/users.svg" alt="members" border="0"/></a>
                            <span className="card-sub-title">Team Members</span>
                        </div>
                        <div class="col-2 text-end">

                        </div>
                    </div>
                    {filter_form}
                </div>
                <div class="card-body">
                    <TeamMemberList team_members_list={team_members_list} />
                </div>
            </div>
        </>
    );
}

/*
    October 10, 2023 Removed Member Filter for now
                            <a href="#"><img class="card-icon-end" src="./images/filter.svg" alt="filter" border="0" onClick={ show_members_filters }/></a>

*/